<template>
  <div class="promotion-data">
    <div class="main-info-container">
      <div class="left-card-info">
        <mk-card
          shadow="never"
          class="card-item"
        >
          <div
            slot="header"
            class="card-title"
          >
            <span class="card-title-value">基础信息</span>
          </div>
          <div class="card-body">
            <div class="info-item">
              <div class="text-info">
                <span class="title">推广内容：</span>
                《{{ baseData.title }}》 <span
                  class="preview-button cursor"
                  @click="articlePreview"
                >预览</span>
              </div>
              <div class="text-info">
                <span class="title">发布公司：</span>

                {{ baseData.accountName }}
              </div>
            </div>
            <div class="info-item">
              <div class="text-info">
                <span class="title">推广状态：</span>
                {{ getTxt(baseData.status) }}
              </div>
              <div class="text-info">
                <span class="title">推广时间：</span>
                {{ handleDate(baseData.startTime) }}~{{ handleDate(baseData.endTime) }}
              </div>
            </div>
            <div class="info-item">
              <div class="text-info">
                <div>
                  出价：
                </div>
                <div>
                  <div>{{ getPayModeFormTxt(baseData.payMode) }}</div>
                  <div>{{ getPayModeCodeTxt(baseData.payMode) }}</div>
                </div>
              </div>
              <div class="text-info">
                <div>预算使用情况：</div>
                <div>
                  <div>总预算金额：{{ Number(baseData.budGet).toFixed(2) }}元，已使用{{ handlePre(baseData.budGet,baseData.consume) }}%</div>
                  <div style="margin-top:4px;">
                    <mk-progress
                      class="progress"
                      :percentage="progress >= 100 ? 100 : progress"
                      :show-text="false"
                    ></mk-progress>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-item">
              <div class="text-info">
                <span class="title">推广备注：</span>
                <span class="leave-words">{{ baseData.remark === '' ? '无' : baseData.remark }}</span>
              </div>
              <div class="text-info">
                发布时间：{{ baseData.createTime }}
              </div>
            </div>
          </div>
        </mk-card>
        <mk-card
          shadow="never"
          class="card-item"
        >
          <div
            slot="header"
            class="card-title"
          >
            <span class="card-title-value">数据信息</span>
          </div>
          <div class="card-body">
            <div class="info-item">
              <div class="text-info">
                累计浏览量（PV）：{{ baseData.pv }}
              </div>
              <div class="text-info">
                累计浏览人数（UV）：{{ baseData.uv }}
              </div>
            </div>
            <div class="info-item">
              <div class="text-info">
                提交表单：{{ baseData.submitCount }}
              </div>
              <div class="text-info">
                识别二维码：{{ baseData.pressQrCodeCount }}
              </div>
            </div>
            <div class="info-item">
              <div class="text-info">
                参与公司数：{{ baseData.attendCompany }}
              </div>
            </div>
          </div>
        </mk-card>
        <mk-card
          shadow="never"
          class="card-item"
        >
          <div
            slot="header"
            class="card-title"
          >
            <span class="card-title-value">结算信息</span>
          </div>
          <div class="card-body">
            <div class="info-item">
              <div class="text-info">
                推广使用金额（元）：{{ baseData.consume }}
              </div>
            </div>
          </div>
        </mk-card>
      </div>
      <div class="right-infinite-list">
        <partake
          :prop-data="compPartake"
          @load="load"
        ></partake>
      </div>
    </div>
    <preview
      :id="articleId"
      :show="showArticle"
      :title="baseData.title"
      @cancel="cancelShow"
    ></preview>
  </div>
</template>
<script>
import partake from './partake.vue'
import preview from '../../preview/index.vue'
import { PROMOTIONAPIS } from '../../../../../api'
export default {
  components: {
    partake,
    preview
  },
  data () {
    return {
      articleId: '', // 文章id
      showArticle: false,
      baseData: {
        title: '',
        accountName: '', // 公司名
        status: 1,
        pv: 0, // 访问量
        uv: 0, // 访问人数
        startTime: '',
        endTime: '',
        payMode: [],
        budGet: 0,
        consume: 0,
        remark: '',
        submitCount: 0, // 提交表单
        pressQrCodeCount: 0, // 识别二维码
        attendCompany: 0 // 收益
        // endReason: '' // 结束原因
      },
      compPartake: [], // 公司参与数据
      page: 1, // 第几页
      isEnd: false, // 是否没有下一页数据
      endReason: ''
    }
  },
  computed: {
    progress () {
      if (this.baseData.budGet) {
        return (
          (Number(this.baseData.consume) * 100) / Number(this.baseData.budGet)
        )
      } else {
        return 0
      }
    }
  },
  created () {
    const user = JSON.parse(localStorage.getItem('user'))
    this.baseData.accountName = user.accountName
    this.articleId = this.$route.query.id
    this.getBaseData()
    this.getStatisticsData()
    this.getPartake()
    // this.getPayModeList()
  },
  methods: {
    cancelShow () {
      this.showArticle = false
    },
    articlePreview () {
      this.showArticle = true
    },
    getTxt (status) {
      let arr = ['待审核', '审核未通过', '进行中', '已结束']
      if (status === 4) {
        return arr[status - 1] + this.endReason
      } else {
        return arr[status - 1]
      }
    },
    getPayModeFormTxt (arr) {
      let str = ''
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].way === 'submitForm') {
          str = '提交表单' + Number(arr[i].unitPay).toFixed(2) + '元/人'
          break
        }
      }
      return str
    },
    getPayModeCodeTxt (arr) {
      let str = ''
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].way === 'longPressQRCode') {
          str = '识别二维码' + Number(arr[i].unitPay).toFixed(2) + '元/人'
          break
        }
      }
      return str
    },
    handleDate (str) {
      if (str.indexOf(' ') > 0) {
        return str.split(' ')[0]
      } else {
        return str
      }
    },
    handlePre (total, num) {
      return ((Number(num) * 100) / Number(total)).toFixed(2)
    },
    // async getPayModeList () {
    // 获取出价方式
    //   const res = await PROMOTIONAPIS.ContentApi.contentPayModeListGet({})
    // },
    async getBaseData () {
      const res = await PROMOTIONAPIS.ContentApi.contentDetailGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.baseData.title = data.title
        this.baseData.createTime = data.createTime
        this.baseData.status = data.status
        this.baseData.payMode = data.payMode
        this.baseData.startTime = data.startTime
        this.baseData.endTime = data.endTime
        this.baseData.budGet = data.budGet
        this.baseData.consume = data.consume
        this.baseData.remark = data.remark
        if (data.endReason) {
          this.endReason = '（' + data.endReason + '）'
        }
      }
    },
    async getStatisticsData () {
      const res = await PROMOTIONAPIS.ContentApi.contentReportGet({
        _id: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.baseData.uv = data.uv
        this.baseData.pv = data.pv
        this.baseData.attendCompany = data.attendCompany
        this.baseData.submitCount = data.submitCount
        this.baseData.pressQrCodeCount = data.pressQrCodeCount
      }
    },
    async getPartake () {
      const res = await PROMOTIONAPIS.ContentApi.contentReportAttendCompanyGet({
        _id: this.$route.query.id,
        page: this.page,
        pageSize: 9
      })
      if (res.success) {
        let data = res.data.data
        if (data && data.length < 9) {
          this.isEnd = true
          let arr = this.compPartake.concat(data)
          this.compPartake = arr
        } else {
          let arr = this.compPartake.concat(data)
          this.compPartake = arr
        }
      }
    },
    load () {
      // 无线滚动滚动到底部事件
      if (!this.isEnd) {
        this.page++
        this.getPartake()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.promotion-data {
  .main-info-container {
    padding: 20px 20px 30px;
    display: flex;

    .left-card-info {
      flex: 3;

      .card-item {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }

      .card-title {
        &::before {
          content: '';
          position: relative;
          margin-right: 8px;
          top: 3px;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: rgba(0, 156, 255, 1);
          border-radius: 1px;
        }
      }

      .card-body {
        .info-item {
          display: flex;
          line-height: 18px;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .text-info {
            flex: 1;
            display: flex;
            font-size: 13px;
            color: #262626;

            .title {
              flex-shrink: 0;
            }

            .preview-button {
              color: #009cff;
            }
          }
        }
      }
    }

    .right-infinite-list {
      margin-left: 20px;
      border: 1px solid #ccc;
      // flex: 2;
      width: 536px;
      // height: 600px;
    }
  }

  /deep/ .el-card__header {
    background-color: #fafafa;
    border-color: #d9d9d9;
    font-size: 14px;
  }

  .leave-words {
    word-wrap: break-word;
    word-break: break-all;
    max-width: 280px;
  }
}
</style>
